import { Injectable } from '@angular/core';
import { BaseCompany } from './base-company.model';
import { disable, prop, propObject, required } from '@rxweb/reactive-form-validators';
import { PersonType } from '../../../../../models/enums/person-type.enum';
import { ResponsibleData } from '../../../../../models/agents/responsible-data';
import { Address } from '../../../../../models/agents/address';
import { UploadCompanyCategoryType } from '../../../../../models/enums/upload-category-type-enum';
import { ResponsibleAddress } from '../../../../../models/agents/responsible-address.enum';

@Injectable()
export class ManagerModel extends BaseCompany {
    constructor(persona?: PersonType) {
        super(persona);
        this.responsibleAddress = new ResponsibleAddress(persona);
        this.responsibleData = new ResponsibleData();
        this.headOfficeAddress = new Address();
        this.allowedFiles = [
            UploadCompanyCategoryType.SocialDocument,
            UploadCompanyCategoryType.DueDiligence,
            UploadCompanyCategoryType.InternalPolicies
        ];
    }

    @propObject(ResponsibleAddress)
    responsibleAddress: ResponsibleAddress;

    @prop()
    cellphone: string;

    @required()
    establishmentDate: string;

    @required()
    mainActivity: string;

    @required()
    cvmProfile: string;

    @required()
    profileClass: string;

    @prop()
    cvmRegisterDate: string;

    @required()
    hasAssetManagmentSeal = false;

    @propObject(ResponsibleData)
    responsibleData: ResponsibleData;

    @propObject(Address)
    headOfficeAddress: Address;
}
